<template>
  <div>
    <el-tabs type="border-card">
      <el-tab-pane style="min-height: 93vh" :label="$t('Mi Cuenta')">
        <center>
          <b v-if="$store.getters.ultima_fecha"><small>Último acceso: {{ $store.getters.ultima_fecha || "" }} / {{
            $store.getters.ultima_ip || "" }}</small></b>
        </center>
        <el-form label-position="top" label-width="100px">
          <el-form-item label="Nombre">
            <el-input :readonly="$store.getters.user.readonly" v-model="user.nombre"></el-input>
          </el-form-item>
          <el-form-item label="Apellido">
            <el-input :readonly="$store.getters.user.readonly" v-model="user.apellido"></el-input>
          </el-form-item>
          <el-form-item label="Nombre de usuario">
            <el-input :readonly="true" v-model="user.rut"></el-input>
            <small style="color: red">* No editable</small>
          </el-form-item>
          <el-form-item label="Email">
            <el-input :readonly="true" v-model="user.email"></el-input>
            <small style="color: red">* No editable</small>
          </el-form-item>
        </el-form>
        <el-alert v-if="!$store.getters.user.readonly" :closable="false" type="warning"
          style="text-align: center"><el-icon class="el-icon-info"
            style="margin-right: 10px; font-size: 20px"></el-icon>Para que los cambios se vean reflejados en la plataforma
          debe cerrar
          sesión y volver a iniciarla nuevamente.</el-alert>
        <br /><br />
        <center v-if="!$store.getters.user.readonly">
          <el-button @click="setUser" icon="el-icon-edit" type="primary">Guardar</el-button>
          <el-button @click="dialogVisible = true" icon="el-icon-more" type="info">Cambiar Contraseña</el-button>
        </center>
      </el-tab-pane>
    </el-tabs>

    <el-dialog title="Cambiar Contraseña" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
      <el-form style="margin-top: 15px" label-position="top" label-width="100px">
        <el-form-item label="Contraseña">
          <el-input type="password" v-model="password" :keyup="validPass(password)"></el-input>
        </el-form-item>
        <el-form-item label="Repita su Contraseña">
          <el-input type="password" v-model="password_repeat"></el-input>
        </el-form-item>
        <span><el-icon v-if="pass_1" style="color: green" class="el-icon-success"></el-icon><el-icon v-else
            style="color: red" class="el-icon-error"></el-icon>
          Longitud mínima 8</span><br />
        <span><el-icon v-if="pass_2" style="color: green" class="el-icon-success"></el-icon><el-icon v-else
            style="color: red" class="el-icon-error"></el-icon>
          Longitud máxima 100</span><br />
        <span><el-icon v-if="pass_3" style="color: green" class="el-icon-success"></el-icon><el-icon v-else
            style="color: red" class="el-icon-error"></el-icon>
          Debe tener letras mayúsculas</span><br />
        <span><el-icon v-if="pass_4" style="color: green" class="el-icon-success"></el-icon><el-icon v-else
            style="color: red" class="el-icon-error"></el-icon>
          Debe tener letras minúsculas</span><br />
        <span><el-icon v-if="pass_5" style="color: green" class="el-icon-success"></el-icon><el-icon v-else
            style="color: red" class="el-icon-error"></el-icon>
          Debe tener al menos 2 dígitos</span><br />
        <span><el-icon v-if="pass_6" style="color: green" class="el-icon-success"></el-icon><el-icon v-else
            style="color: red" class="el-icon-error"></el-icon>
          No debe tener espacios</span>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" @click="handleClose">Cancelar</el-button>
        <el-button size="medium" type="primary" @click="setPassword">Aceptar</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      user: {},
      dialogVisible: false,
      password: "",
      password_repeat: "",
      pass_1: false,
      pass_2: false,
      pass_3: false,
      pass_4: false,
      pass_5: false,
      pass_6: false,
    };
  },
  created() {
    this.$store.dispatch("setSubTitle", "Administración de mi cuenta");
    this.user = JSON.parse(JSON.stringify(this.$store.getters.user));
  },
  methods: {
    setPassword() {
      if (this.password !== this.password_repeat) {
        this.$alert(
          "Las contraseñas ingresadas no coinciden",
          "Información importante",
          {
            type: "error",
            confirmButtonText: "Aceptar",
            callback: (action) => { },
          }
        );
      } else {
        var passwordValidator = require("password-validator");

        // Create a schema
        var schema = new passwordValidator();

        // Add properties to it
        schema
          .is()
          .min(8) // Minimum length 8
          .is()
          .max(100) // Maximum length 100
          .has()
          .uppercase() // Must have uppercase letters
          .has()
          .lowercase() // Must have lowercase letters
          .has()
          .digits(2) // Must have at least 2 digits
          .has()
          .not()
          .spaces() // Should not have spaces
          .is()
          .not()
          .oneOf([]); // Blacklist these values

        if (schema.validate(this.password)) {
          this.updatePassword();
        } else {
          this.$alert(
            "La contraseña ingresada no cumple con los requisitos solicitados",
            "Información importante",
            {
              type: "error",
              confirmButtonText: "Aceptar",
              callback: (action) => { },
            }
          );
        }
      }
    },
    validPass(pass) {
      // minimo de 8
      if (pass.length >= 8) {
        this.pass_1 = true;
      } else {
        this.pass_1 = false;
      }
      // maximo de 100
      if (pass.length <= 100) {
        this.pass_2 = true;
      } else {
        this.pass_2 = false;
      }
      // mayusculas
      if (this.tiene_mayusculas(pass) === true) {
        this.pass_3 = true;
      } else {
        this.pass_3 = false;
      }
      // minusculas
      if (this.tiene_minusculas(pass) === true) {
        this.pass_4 = true;
      } else {
        this.pass_4 = false;
      }
      // minimo dos numeros
      if (this.getNumbersInString(pass).length >= 2) {
        this.pass_5 = true;
      } else {
        this.pass_5 = false;
      }
      // sin espacios
      var noValido = / /;
      if (noValido.test(pass)) {
        this.pass_6 = false;
      } else {
        this.pass_6 = true;
      }
    },
    getNumbersInString(string) {
      var tmp = string.split("");
      var map = tmp.map(function (current) {
        if (!isNaN(parseInt(current))) {
          return current;
        }
      });

      var numbers = map.filter(function (value) {
        return value != undefined;
      });

      return numbers.join("");
    },
    tiene_minusculas(texto) {
      var letras = "abcdefghyjklmnñopqrstuvwxyz";
      for (var i = 0; i < texto.length; i++) {
        if (letras.indexOf(texto.charAt(i), 0) != -1) {
          return true;
        }
      }
      return false;
    },
    tiene_mayusculas(texto) {
      var letras_mayusculas = "ABCDEFGHYJKLMNÑOPQRSTUVWXYZ";
      for (var i = 0; i < texto.length; i++) {
        if (letras_mayusculas.indexOf(texto.charAt(i), 0) != -1) {
          return true;
        }
      }
      return false;
    },
    handleClose() {
      this.dialogVisible = false;
      this.password = "";
      this.password_repeat = "";
      this.pass_1 = false;
      this.pass_2 = false;
      this.pass_3 = false;
      this.pass_4 = false;
      this.pass_5 = false;
      this.pass_6 = false;
    },
    async setUser() {
      const response = await axios.post(
        `/usuarios/editUserBasic/${this.$store.getters.user._id}`,
        {
          nombre: this.user.nombre,
          apellido: this.user.apellido,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      if (response.data.success === true) {
        this.$alert(response.data.message, "Información importante", {
          type: "success",
          confirmButtonText: "Aceptar",
          callback: (action) => { },
        });
      } else {
        this.$alert(response.data.message, "Información importante", {
          type: "error",
          confirmButtonText: "Aceptar",
          callback: (action) => { },
        });
      }
    },
    async updatePassword() {
      const response = await axios.post(
        `/usuarios/setPassword/${this.$store.getters.user._id}`,
        {
          password: this.password,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      if (response.data.success === true) {
        this.$alert(response.data.message, "Información importante", {
          type: "success",
          confirmButtonText: "Aceptar",
          callback: (action) => {
            this.handleClose();
          },
        });
      } else {
        this.$alert(response.data.message, "Información importante", {
          type: "error",
          confirmButtonText: "Aceptar",
          callback: (action) => {
            this.handleClose();
          },
        });
      }
    },
  },
};
</script>

<style scoped></style>